const hasRiskFactors = require('./hasRiskFactors')
const isSelbstbehaltAllowed = require('./isSelbstbehaltAllowed')

// Ein gespeicherter Wert bleibt nur erhalten, wenn er dauerhaft intern ist – also auch ohne Risiko
// nicht wählbar wäre. Fällt er erst durch eine risikoerhöhende Angabe weg, muss er neu gewählt
// werden, sonst lehnt der Server das Speichern ab (services/hs_order/hooks/checkSelbstbehalt.js).
function bleibtAlsBestandswert (selbstbehalt, { can, currentValue }) {
  if (selbstbehalt.api !== currentValue) return false
  return !isSelbstbehaltAllowed(selbstbehalt, { can, hasRisk: false })
}

// Baut die Select-Optionen für einen Selbstbehalt-Enum. Ein bereits gespeicherter Wert bleibt über
// currentValue als nicht wählbare Option in der Liste, damit er beim Bearbeiten nicht verloren geht.
module.exports = function getSelbstbehaltOptions (selbstbehaltEnum, { order, can, currentValue }) {
  const hasRisk = hasRiskFactors(order)
  return Object.values(selbstbehaltEnum)
    .filter(selbstbehalt => isSelbstbehaltAllowed(selbstbehalt, { can, hasRisk }) || bleibtAlsBestandswert(selbstbehalt, { can, currentValue }))
    .map(selbstbehalt => ({
      label: selbstbehalt.human,
      value: selbstbehalt.api,
      disabled: !isSelbstbehaltAllowed(selbstbehalt, { can, hasRisk })
    }))
}
